import { render, staticRenderFns } from "./dimensionTableDialog.vue?vue&type=template&id=9f63e618&scoped=true"
import script from "./dimensionTableDialog.vue?vue&type=script&lang=js"
export * from "./dimensionTableDialog.vue?vue&type=script&lang=js"
import style0 from "./dimensionTableDialog.vue?vue&type=style&index=0&id=9f63e618&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f63e618",
  null
  
)

export default component.exports